import { render } from "./DbaDocumentView.vue?vue&type=template&id=0bbdb80d"
import script from "./DbaDocumentView.vue?vue&type=script&lang=js"
export * from "./DbaDocumentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__